import axios from '../http.js'
import letter from './letter.js'
function getMenuData() {
	return new Promise((resolve, reject) => {
			axios.get('sysMenu/rootMenuJson', {
				params: {}
			}).then((res) => {
	      var a = res.data
				var firstFloor = a.filter(function(el) {
	                el['title'] = el['name']
					return el['parentId'] == 0
				})
				resolve(computerNewSchoolList2(a, firstFloor))
			})
	})
}

function computerNewSchoolList2(data, data2) {

  if (data2 != '' && data2 != []) {
    for (var j = 0; j < data2.length; j++) {
      var gradeList = data.filter(function(el) {
        return data2[j]["id"] == el["parentId"]
      })
      if(gradeList.length>0){
        data2[j]["children"] = gradeList
      }else{
        data2[j]["children"] = []
      }

      computerNewSchoolList2(data, gradeList)

    }


  } else {

  }
  // localStorage.setItem("schoolTree", JSON.stringify(data2))

  return data2
}
function getSchoolData(rootid) {
	return new Promise((resolve, reject) => {
		// if (localStorage.getItem('schoolTree')!='null' && localStorage.getItem('schoolTree') !='') {

		// 	resolve(localStorage.getItem('schoolTree'))
		// } else {
      var rootids = ''
      if(rootid == 'all'){
          rootids = ''
      }else{
        rootids = rootid ? rootid:'news'
      }
			axios.get('dic/getQueryList', {
				params: {
           rootid:rootids,
           length:-1
        }
			}).then((res) => {
        var a = res.data
				a.map(function(val,index){
					val['title']=val['name']
					val['label']=val['name']
					val['value']=val['guid']
          if(val['pid']!=0){
             val['selfid'] = val['pid']
          }else{
            val['selfid'] = ''
          }

				})
				var firstFloor = a.filter(function(el) {

					return el['pid'] == 0
				})
				resolve(computerNewSchoolList(a, firstFloor))

			})
		 // }

	})
}

function computerNewSchoolList(data, data2) {
	if (data2 != '' && data2 != []) {


		for (var j = 0; j < data2.length; j++) {

			var gradeList = data.filter(function(el) {
				return data2[j]["guid"] == el["pid"]
			})
			if(gradeList.length>0){
        gradeList.map(function(val,index){
           if(data2[j]['selfid']!=""){
              val['selfid'] = data2[j]['selfid']+"_"+val['selfid']
           }

        })
				data2[j]["children"] = gradeList
			}else{
				data2[j]["children"] = []
			}

			computerNewSchoolList(data, gradeList)

		}


	} else {

	}
  // localStorage.setItem("schoolTree", JSON.stringify(data2))

	return data2
}
function getRoleData() {
	return new Promise((resolve, reject) => {

			axios.get('sysRole/loadRoleList.do', {
				params: {}
			}).then((a) => {
				localStorage.setItem("inch_roleData", JSON.stringify(a))
				resolve(JSON.stringify(a))
			})


	})
}

function getPartData(schoolid) {

	return new Promise((resolve, reject) => {

			axios.get('depart/loadDepart', {
				params: {schoolid:schoolid}
			}).then((a) => {
				localStorage.setItem("inch_partData", JSON.stringify(a))
				resolve(JSON.stringify(a))
			})


	})
}
function getKM(schoolid){
  return new Promise((resolve, reject) => {

  		axios.get('videoItem/getQueryList', {
  			params: {schoolid:schoolid,length:-1}
  		}).then((a) => {
  			localStorage.setItem("inch_kmData", JSON.stringify(a.data))
  			resolve(JSON.stringify(a.data))
  		})


  })
}
function getLcdData(schoolid) {
	return new Promise((resolve, reject) => {

			axios.get('lcd/loadLcd.do', {
				params: {schoolid:schoolid,model:6}
			}).then((a) => {
				localStorage.setItem("inch_lcdData", JSON.stringify(a.data))
				resolve(JSON.stringify(a.data))
			})


	})
}
function getSignData(){
	return new Promise((resolve, reject) => {

			axios.get('teachSignTimeConfig/getSignConfig', {
				params: {}
			}).then((a) => {
				localStorage.setItem("inch_signData", JSON.stringify(a.data))
				resolve(JSON.stringify(a.data))
			})


	})
}

function getTeachData(){
	return new Promise((resolve, reject) => {

			axios.get('webUser/dataList', {params:{length:-1}}).then((res) => {
        var a = res.data
				a.map(function(val,index){
					val['label'] = val['name']
					val['key'] = val['guid']
				})
				localStorage.setItem("inch_teachData", JSON.stringify(a))
				resolve(JSON.stringify(a))
			})


	})
}
function getAppCenterData(){
	return new Promise((resolve, reject) => {

			axios.get('sysPermission/menu', {params:{flag:1}}).then((res) => {
				var a = res.data
				var newdata = a.filter(function(val,index){
						return val['parentId'] == 0
					})
				var finallyData = JSON.stringify(computerAppCenter(a,newdata))
				localStorage.setItem("inch_appcenterData", finallyData)
				resolve(finallyData)
			})


	})
}
function computerAppCenter(data, newdata,flag) {

	if(flag){
		for(var i=0;i<newdata.length;i++){
			newdata[i]['children'] = []
			newdata[i]['ahref'] = letter.GetJP(newdata[i]['name'])
			for(var j=0;j<data.length;j++){
				if(newdata[i]['id']==data[j]['parentId']){
					data[j]['ahref'] = letter.GetJP(data[j]['name'])
					newdata[i]['children'].push(data[j])
				}
			}
		}
		return newdata
	}else{
		var secondMenu = []
		for(var i=0;i<newdata.length;i++){
			for(var j=0;j<data.length;j++){
				if(newdata[i]['id']==data[j]['parentId']){
					secondMenu.push(data[j])
				}
			}
		}
			return computerAppCenter(data,secondMenu,true)
	}
}
function getAppNavData(){
	return new Promise((resolve, reject) => {

			axios.get('sysPermission/menu', {params:{}}).then((res) => {
				var a = res.data
				var newdata = a.filter(function(val,index){
						return val['parentId'] == 0
					})
				var finallyData = JSON.stringify(computerAppCenter(a,newdata,true))
				localStorage.setItem("inch_appnavData",finallyData)
				resolve(finallyData)
			})


	})
}
export default {
	getSchoolData,
	getRoleData,
	getPartData,
	getLcdData,
	getSignData,
	getTeachData,
	getAppCenterData,
	getAppNavData,
  getKM,
  getMenuData
}
